const ButtonSender = ({ onClick, children, disabled = false }) => {
    return(
        <button
            className="button-sender"
            id="button-sender"
            onClick={onClick}
            disabled={disabled}
            style={disabled ? { cursor: "not-allowed", opacity: 0.6 } : undefined}
        >
            {children}
        </button>
    );
}

export default ButtonSender;